var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGolfutureLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 270.17 46.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Golfuture_Logo_Horizontal_Full_Colour") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "typography"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.76,32.62l-46,8.81q-1.15,2.07-2.15,4.23l48.37,0,9.33-24.12H62.44Z",
    fill: "#69f32f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.71,1.54C35.28,1.54,8.54,20.3,2,45.69H22c.63-1.38,14.37-34.29,53.49-34.29a58.55,58.55,0,0,1,29.17,7.75A58.7,58.7,0,0,0,62.71,1.54Z",
    fill: "#001d5d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.74,37.71c1.6-5,6.15-8.29,13.68-8.29,5.29,0,7.2,2.28,7.2,2.28l-3.28,2.89a9.23,9.23,0,0,0-5.07-1.31c-4.88,0-7,2.21-7.78,4.43s-.23,4.44,4.65,4.44a10.79,10.79,0,0,0,3.72-.47l.79-2.23h-4L95.86,36h8.3l-2.93,8.28C99.12,45.57,95.9,46,93,46,85.46,46,83.28,42.31,84.74,37.71Z",
    fill: "#001d5d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.81,37.71c1.59-5,6.14-8.29,13.67-8.29s9.72,3.69,8.26,8.29c-1.59,5-6.16,8.3-13.69,8.3S104.35,42.31,105.81,37.71Z",
    fill: "#001d5d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,37.71c.79-2.22.23-4.43-4.65-4.43s-7,2.21-7.78,4.43-.23,4.44,4.65,4.44S122.2,39.94,123,37.71Z",
    fill: "#69f32f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.2 41.71 144.28 41.71 142.92 45.57 127.13 45.57 132.68 29.86 137.39 29.86 133.2 41.71",
    fill: "#001d5d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.46 36.33 163.14 40.09 151.8 40.09 149.87 45.57 145.16 45.57 150.72 29.86 167.29 29.86 165.92 33.72 154.06 33.72 153.13 36.33 164.46 36.33",
    fill: "#001d5d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.06,38.33l3-8.47h4.7l-3,8.47C183,43.2,180,46,173.17,46c-6,0-8.19-2.81-6.47-7.68l3-8.47h4.7l-3,8.47c-.84,2.37-.43,3.82,2.93,3.82S179.22,40.7,180.06,38.33Z",
    fill: "#001d5d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.03 29.86 206.66 33.72 199.89 33.72 195.7 45.57 191 45.57 195.19 33.72 188.41 33.72 189.78 29.86 208.03 29.86",
    fill: "#001d5d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.49,38.33l3-8.47h4.7l-3,8.47C223.47,43.2,220.42,46,213.61,46c-6,0-8.2-2.81-6.48-7.68l3-8.47h4.7l-3,8.47c-.84,2.37-.44,3.82,2.92,3.82S219.65,40.7,220.49,38.33Z",
    fill: "#001d5d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,29.86H230.46l-5.55,15.71h4.71l1.71-4.86h5.43l1,4.86h5l-1.21-5.78a7,7,0,0,0,4.64-4.33C247.5,31.35,245.09,29.86,241,29.86Zm.48,5.6c-.43,1.22-1.38,1.73-3.07,1.73h-5.79l1.23-3.46h5.78C241.28,33.73,241.86,34.24,241.43,35.46Z",
    fill: "#001d5d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.47 35.74 263.14 39.5 251.81 39.5 251.03 41.71 263.01 41.71 261.64 45.57 244.96 45.57 250.51 29.86 267.08 29.86 265.72 33.72 253.85 33.72 253.14 35.74 264.47 35.74",
    fill: "#001d5d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfutureLogo);
export default __webpack_public_path__ + "static/media/golfuture-logo.4345da5c0506b8d6bac8fae895364bc5.svg";
export { ForwardRef as ReactComponent };